import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface ModalVariationCloseProps {
  showDialog: boolean;
  cancelNavigation: any;
  confirmNavigation: any;
}

export const ModalVariationClose: React.FC<ModalVariationCloseProps> = ({
  showDialog,
  cancelNavigation,
  confirmNavigation,
}) => {
  const { t } = useTranslation();
  return (
    <Modal show={showDialog} style={{ backgroundColor: "rgba(0, 0, 0, 0.4)" }}>
      <Modal.Header>
        <Modal.Title>{t("global.warning")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4>
          <b>{t("modals.some_changes")}</b>
        </h4>
        <br />

        <h5>Are you sure you want to close variation modal?</h5>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={cancelNavigation}>
          {t("global.no")}
        </Button>
        <Button variant="danger" onClick={confirmNavigation}>
          {t("global.yes")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
